import axios from "axios"
import { anonymus } from "@/utils/auth"
import { API_URI } from "@/config/API_URI"

export const postContactFormQuery = (
    email?: string,
    message?: string,
    name?: string,
    rodo_1?: boolean,
    rodo_2?: boolean,
    phone?: string,
) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${API_URI}mail/`, {
                email: email || "",
                first_name: name || "",
                last_name: name || "",
                phone_number: phone || "",
                message: `${message || ""} RODO 1: ${rodo_1} RODO 2: ${rodo_2}` || "",
                company_name: "",
                language: "EN",
	            title: "Contact",
	            additional_info: `RODO 1: ${rodo_1} RODO 2: ${rodo_2}`
            }, anonymus())
            .then(response => resolve(response?.data))
            .catch(error => reject(error))
    })
}